export const REGION_DEFAULT_CALLING_CODES = {
  UK: "+44",
  US: "+1",
  EU: "+49",
  AU: "+61",
  CA: "+1",
  IN: "+91",
};

export const DEFAULT_REGION_FLAG = {
  UK: "GB",
  US: "US",
  EU: "DE",
  AU: "AU",
  CA: "CA",
  IN: "IN",
};

export const getRegionCallingCode = (region?: string): string => {
  if (!region) return "+44";

  const callingCode =
    REGION_DEFAULT_CALLING_CODES[
      region as keyof typeof REGION_DEFAULT_CALLING_CODES
    ];

  return callingCode || "+44";
};

export const getRegionFlag = (region?: string): string => {
  if (!region) return "GB";

  const flag = DEFAULT_REGION_FLAG[region as keyof typeof DEFAULT_REGION_FLAG];

  return flag || "GB";
};
